(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tcc", [], factory);
	else if(typeof exports === 'object')
		exports["tcc"] = factory();
	else
		root["tcc"] = factory();
})(window, function() {
return 